module.exports = __webpack_public_path__ + "img/event_top_image.1959ccdf.jpeg";